import { Col, Row, Modal, message } from 'antd';
import React, { useState, useRef, useEffect, useContext, useMemo, useCallback, } from 'react'
import { PlusOutlined } from '@ant-design/icons';
import { Divider, Input, Select, Space, Button, Form } from 'antd';
import commonLib from '../../../control/commonLib';
import konsole from '../../../network/konsole';
import Services from '../../../network/Services';
// import JoditEditor, { EditorState, ContentState, htmlToDraft } from "jodit-react";
// import Jodit from 'jodit';
// import 'jodit/build/jodit.min.css';
import "./communicationmodal.css";
import { UserContext } from "../../../App.js";
import Element from 'antd/lib/skeleton/Element';
import { ModalBody } from 'react-bootstrap';
import config from "../../../config.json"
import AtTheRateTextArea from '../AtTheRateTextArea';
import { formatPhoneNumberWithoutCntryCode_WIthoutBracket, isNullUndefine } from '../../../control/Constant.js';



let index = 0;

let initialContent = `<table border="0" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td style="padding: 40px 0 40px 0;"><table style="border: 1px solid #cccccc; border-collapse: collapse; max-width: 55rem; word-break: break-all; min-width: 800px;" border="0" cellspacing="0" cellpadding="0" align="center"><tbody><tr>
<td style="border-bottom: 1px; border-bottom-style: solid; padding: 20px 0 30px 0; color: #153643; font-size: 28px; font-weight: bold; font-family: Arial, sans-serif;" align="center">
<p style="font-size: 16px; font-weight: bold; font-family: sans-serif; text-decoration: none; line-height: 40px; width: 100%; display: inline-block; color: #871a27 !important;">@@SUBTENANTNAME</p>
</td></tr><tr><td style="padding: 20px;" bgcolor="#ffffff"><table border="0" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td style="padding: 20px 10px 30px 10px; color: #153643; font-family: Arial, sans-serif; font-size: 16px; line-height: 20px; text-align: start;">Please enter your email text here.</td></tr><tr><td bgcolor="#5B5452" style="background-color:#5B5452;padding:42px 40px;"><table border="0" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td width="50%" valign="top" style="vertical-align:top;padding-right:25px;"><img src="@@FIRMLOGO" alt="Firm logo" width="180" height="72"  style="display:block;margin-bottom:30px;object-fit:contain;"><p style="color:#ffffff;font-family:Arial,sans-serif;font-size:15px;font-weight:500;text-align:start;line-height:26px;">@@FIRMADDRESS</p></td><td width="50%" valign="top" style="vertical-align:top;"><table border="0" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td width="45" style="padding-bottom:30px;text-align:center;"><img src="https://cdn-icons-png.flaticon.com/512/561/561127.png" width="22" height="22" style="display:block;margin:auto;filter:brightness(0) saturate(100%) invert(70%) sepia(37%) saturate(689%) hue-rotate(356deg) brightness(92%) contrast(89%);"></td><td valign="middle" style="color:#ffffff;font-family:Arial,sans-serif;font-size:15px;font-weight:500;padding-left:12px;text-align:start;padding-bottom:30px;">@@FIRMEMAIL</td></tr><tr><td width="45" style="padding-bottom:30px;text-align:center;"><img src="https://cdn-icons-png.flaticon.com/512/44/44386.png" width="22" height="22" style="display:block;margin:auto;filter:brightness(0) saturate(100%) invert(70%) sepia(37%) saturate(689%) hue-rotate(356deg) brightness(92%) contrast(89%);"></td><td valign="middle" style="color:#ffffff;font-family:Arial,sans-serif;font-size:15px;font-weight:500;padding-left:12px;text-align:start;padding-bottom:30px;">@@FIRMWEBSITE</td></tr><tr><td width="45" style="text-align:center;"><img src="https://cdn-icons-png.flaticon.com/512/126/126341.png" width="22" height="22" style="display:block;margin:auto;filter:brightness(0) saturate(100%) invert(70%) sepia(37%) saturate(689%) hue-rotate(356deg) brightness(92%) contrast(89%);"></td><td valign="middle" style="color:#ffffff;font-family:Arial,sans-serif;font-size:15px;font-weight:500;text-align:start;padding-left:12px;">@@FIRMPHONE</td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td bgcolor="#D29C48" style="background-color:#D29C48;padding:10px 20px;text-align:center;"><table border="0" cellspacing="0" cellpadding="0" align="center"><tbody><tr><td style="color:#ffffff;font-family:Arial,sans-serif;font-size:20px;font-weight:500;padding-right:22px;">Powered by</td><td style="padding-right:20px;vertical-align:middle;"><img src="https://devintakeformdocs.blob.core.windows.net/aodocs/b503a019-1f3d-403d-a0ee-584448d96229/10/18/lstshbhjriu.png" width="40" height="40" style="display:block;"></td><td style="color:#ffffff;font-family:Arial,sans-serif;font-size:20px;font-weight:500;">AgingOptions</td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table>`


export const Addcommunicationmodal = (props) => {
    // const [placeHolder,setPlaceHolder] = useState("Please enter your email text here")
    konsole.log("plplplpl", config.SUBTENANT_ID)



    const [form] = Form.useForm();
    // const editor = useRef(null);
    const { setLoader } = useContext(UserContext)
    const [items, setItems] = useState([]);

    const [lastdata, setlastdata] = useState(false)
    const [getChannelValue, setChannelValue] = useState()
    const [getOccurrenceSelectedValue, setOccurrenceSelectedValue] = useState()
    const [getSelectRoleFromValue, setSelectRoleFromValue] = useState("")
    const [getSelectRoleToValue, setSelectRoleToValue] = useState("")
    const [getCreateValue, setCreateValue] = useState("");
    const [showDropDown, setShowDropDown] = useState(false);
    const [CreateNewButtonId, setCreateNewButtonId] = useState(false);
    const [uploadPreTempDropDown, setuploadPreTempDropDown] = useState(false);
    const [isDisabled, setISDisabled] = useState(false)
    const [isDisabledInblidTemplate, setISDisabledInblidTemplate] = useState(false)
    const [commonChannelSelect, setCommonChannelSelect] = useState([]);
    const [getUserRoleSelect, setUserRoleSelect] = useState([])
    const [getEmailTemplateSelect, setEmailTemplateSelect] = useState(false)
    const [getTextTemplateSelect, setTextTemplateSelect] = useState(false)
    const [getOccurrenceSelect, setOccurrenceSelect] = useState([]);
    const [getEmailSubjectValue, setEmailSubjectValue] = useState();
    const [postOccurrence, setPostOccurrence] = useState()
    const [getCkEditorText, setCkEditorText] = useState("")
    const [getCkEditorEmail, setCkEditorEmail] = useState("")
    const [postCkEditorText, setPostCkEditorText] = useState([])
    const [putCkEditorText, setPutCkEditorText] = useState([])
    const [postCkEditorEmail, setPostCkEditorEmail] = useState([])
    const [callpostAllData, setPostAllData] = useState([]);
    const [callPutAllData, setPutAllData] = useState([])
    const [GetCommMediumData, setCommMediumData] = useState([]);
    const [GetCommMediumData1, setCommMediumData1] = useState([]);

    const [inblidEmailTemplate, setInblidEmailTemplate] = useState([])
    const [inblidTextTemplate, setInblidTextTemplate] = useState([])
    const [subjectEmailData, setSubjectEmailData] = useState()

    const [getSelectedEmailTemplateData, setSelectedEmailTemplateData] = useState([])
    const [getSelectedTextTemplateData, setSelectedTextTemplateData] = useState([])
    const [updateText, setUpdateText] = useState(false)
    const [RoleFromLength, setRoleFromLength] = useState(0)
    const [RoleToLength, setRoleToLength] = useState(0)
    const [fromRoleIdd, setfromRoleId] = useState(0)
    const [toRoleId, settoRoleId] = useState(0)
    const [isTrueValue, setIsTrueValue] = useState(false)
    const [isStopApi, setISStopApi] = useState(false)
    const [EmailSubject, setEmailSubject] = useState("");
    const [preDefineEmailTemplateData, setPreDefineEmailTemplateData] = useState("")
    const [comChanID, setComChanID] = useState(GetCommMediumData[0]?.commChannelId)
    const [addOccuranceName, setOccuranceName] = useState()
    const [EmailTemtID, setEmailTemopID] = useState()
    const [subtenantID, setSubtenantID] = useState()

    const [selectedChannelID, setSelectedChannelID] = useState()
    const [ckeditorID, setCkEditorID] = useState(4)
    const [ckeditorIDEmail, setCkeditorIDEmail] = useState(4)
    const [selectedFromID, setSelectedFromID] = useState(2)
    const [selectedToID, setSelectedToID] = useState(2)
    const [templateDataEdit, setTemplateDataEdit] = useState(initialContent);
    const [open, setOpen] = useState(false);
    const [OccurrencNameIsTrue, setOccurrencNameIsTrue] = useState()
    const [cktext, setCkText] = useState()
    const [preDefineTemplateId, setPreDefineTemplateId] = useState(4)
    const [textMessage, setTextMessage] = useState()
    const [showSerchTrue, setShowSerchTrue] = useState(true)
    const [createLinkState, setCreateLinkState] = useState(false)
    const [selectedChannelLinkID, setSelectedChannelLinkID] = useState()
    const [firstselect1, setselect1] = useState(false)
    const [firstselect2, setselect2] = useState(false)
    const [firstselect3, setselect3] = useState(false)
    const [firstselect4, setselect4] = useState(false)
    const [subtinentDatials, setSubtinentDatials] = useState()
    const [occuranceId, setOccuranceId] = useState(0);
    const [openChannelDropdown, setOpenChannelDropdown] = useState(false);
    const [openFromDropdown, setOpenFromDropdown] = useState(false);
    const [openToDropdown, setOpenToDropdown] = useState(false);
    const [fromSearchText, setFromSearchText] = useState("");
    const [toSearchText, setToSearchText] = useState("");
    const fromDropdownRef = useRef(null);
    const toDropdownRef = useRef(null);

    let userId = commonLib.getObjFromStorage("stateObj").userId
    const inputFieldRef = useRef()
    const buttonFieldRef = useRef()

    // console.log("UserID", userId)

    konsole.log("textMessagetextMessage", document?.getElementById("testAreaId")?.innerHTML)


    const [name, setName] = useState("");
    const inputRef = useRef(null);


    useEffect(() => {
        konsole.log("initialContentinitialContent", initialContent)
        let subtenantID = commonLib.getSessionStoarge("subtenantId")
        setSubtenantID(subtenantID)
        getCommonChannelfunction();
        getUserRolesfunction();
        getOccurrencefunction(subtenantID);
        // setTemplateDataEdit(initialContent)
        getPreEmailTemplatesPathApiFunction(subtenantID)
    }, [])

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (fromDropdownRef.current && !fromDropdownRef.current.contains(e.target)) {
                setOpenFromDropdown(false);
                setFromSearchText("");
            }
            if (toDropdownRef.current && !toDropdownRef.current.contains(e.target)) {
                setOpenToDropdown(false);
                setToSearchText("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const subtenantId = commonLib.getObjFromStorage("subtenantId");
        if (isNullUndefine(subtinentDatials)) {
            Services.getSubtenantDetail(subtenantId, true)
                .then((res) => {
                    setSubtinentDatials(res.data?.data[0])
                    setAllDetails(res.data?.data[0])

                })
                .catch((err) => {
                    // konsole.log("ErrorData", err);
                });
        }
    }, []);
    const toTitleCase = (str) => str?.split(" ")?.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");


    const replaceTemplate = (temp, data, addres) => {
        let TemplateContent = temp;
        const userDetails = JSON.parse(sessionStorage.getItem('userLoggedInDetail'))
        TemplateContent = TemplateContent?.replace("@@FIRMNAME", toTitleCase(data?.subtenantName))
        TemplateContent = TemplateContent?.replace("@@FIRMLOGO", data?.subtenantLogoUrl)
        TemplateContent = TemplateContent?.replace("@@FIRMADDRESS", addres || "")
        TemplateContent = TemplateContent?.replace("@@FIRMEMAIL", data?.contacts?.emails?.[0]?.emailAddresses || "")
        TemplateContent = TemplateContent?.replace("@@FIRMWEBSITE", data?.websiteUrl || '')
        TemplateContent = TemplateContent?.replaceAll("@@FIRMPHONE", formatPhoneNumberWithoutCntryCode_WIthoutBracket(data?.contacts?.mobileNos?.[0]?.mobileNo))
        return TemplateContent;
    }

    const setAllDetails = async (res) => {
        const address = await getAddressByAddressid(res?.addressId)
        setTemplateDataEdit(replaceTemplate(initialContent, res, address?.addressLine1))
        //    console.log("sdklfjdkfjlkdjf",address)  
    }

    const getAddressByAddressid = (id) => {
        return new Promise(async (resolve, reject) => {
            Services.getAddressId(id).then((res) => {
                let address = res?.data?.data
                resolve(address)
            }).catch((err) => {
                resolve('err')
            })
        });
    }
    function mergeEmailTemplates(oldTemplate, newTemplate) {
        const parser = new DOMParser();
        const oldDoc = parser.parseFromString(oldTemplate, 'text/html');
        const newDoc = parser.parseFromString(newTemplate, 'text/html');

        const footerColors = [
            '#5b5452', '#d29c48', '#6d6864',
            '#5B5452', '#D29C48', '#6D6864'
        ]?.map(c => c.toLowerCase());

        const isInsideFooter = (el) => {
            let parent = el.parentElement;
            while (parent) {
                const bg = (
                    parent.getAttribute?.('bgcolor') ||
                    parent.getAttribute?.('style')?.match(/background-color\s*:\s*(#[0-9a-fA-F]+)/i)?.[1] ||
                    ''
                ).toLowerCase();
                if (footerColors.includes(bg)) return true;
                parent = parent.parentElement;
            }
            return false;
        };

        const isFooterTd = (td) => {
            const bg = (
                td.getAttribute('bgcolor') ||
                td.getAttribute('style')?.match(/background-color\s*:\s*(#[0-9a-fA-F]+)/i)?.[1] ||
                ''
            ).toLowerCase();
            return footerColors.includes(bg);
        };

        // ── NEW: capture full td attributes (style + align + valign + bgcolor) ──
        const captureAttrs = (td) => ({
            style: td.getAttribute('style') || null,
            align: td.getAttribute('align') || null,
            valign: td.getAttribute('valign') || null,
            bgcolor: td.getAttribute('bgcolor') || null,
        });

        // ── NEW: apply all captured attrs to placeholder td ──────────────────
        const applyAttrs = (targetTd, attrs) => {
            // Reset new template's default styles first so nothing bleeds in
            const neutralize = 'font-family:inherit;font-size:inherit;color:inherit;line-height:inherit;padding:0;margin:0;';
            const combined = attrs.style ? `${attrs.style}` : neutralize;
            targetTd.setAttribute('style', combined);
            if (attrs.align) targetTd.setAttribute('align', attrs.align);
            if (attrs.valign) targetTd.setAttribute('valign', attrs.valign);
            if (attrs.bgcolor) targetTd.setAttribute('bgcolor', attrs.bgcolor);
        };

        let bodyHTML = null;
        let originalAttrs = null;

        // ── STEP 1: Find bgcolor="#ffffff" td ─────────────────────────────────
        const whiteBodyTd = [...oldDoc.querySelectorAll('td')].find(td => {
            const bg = (td.getAttribute('bgcolor') || '').toLowerCase().trim();
            if (bg !== '#ffffff' && bg !== 'ffffff') return false;
            if (isInsideFooter(td)) return false;
            return true;
        });

        if (!whiteBodyTd) {
            // console.log('❌ white td not found');
            return newTemplate;
        }

        // ── STEP 2: Clone and remove footer rows ──────────────────────────────
        const clone = whiteBodyTd.cloneNode(true);
        clone.querySelectorAll('tr').forEach(tr => {
            const trHtml = tr.innerHTML?.toLowerCase() || '';
            const hasFooter = footerColors?.some(c => trHtml.includes(c.replace('#', '')));
            if (hasFooter) tr.remove();
        });

        const whiteTdText = clone.textContent?.trim() || '';

        if (whiteTdText?.length > 5) {
            const firstChild = clone.firstElementChild;
            const startsWithTable = firstChild?.tagName?.toLowerCase() === 'table';

            if (startsWithTable) {
                const nestedTable = clone.querySelector(':scope > table');
                const contentTds = [...nestedTable.querySelectorAll(':scope > tbody > tr > td')]?.filter(td => {
                    if (isFooterTd(td)) return false;
                    if (isInsideFooter(td)) return false;
                    const text = td.textContent?.trim() || '';
                    if (text?.length < 2) return false;
                    return true;
                });

                if (contentTds?.length > 0) {
                    originalAttrs = captureAttrs(contentTds[0]); // ← full attrs
                    // bodyHTML = contentTds?.map(td => td.innerHTML.trim()).join('');
                    bodyHTML = contentTds?.map(td => `<div style="margin:0;padding:0;">${td.innerHTML.trim()}</div>`).join('')
                }
            } else {
                originalAttrs = captureAttrs(whiteBodyTd); // ← full attrs
                bodyHTML = clone.innerHTML.trim();
            }
        }

        // ── STEP 3: white td empty → scan sibling trs ────────────────────────
        if (!bodyHTML || bodyHTML.trim()?.length < 5) {
            // console.log('⚠️ white td empty — scanning sibling trs...');

            const parentTr = whiteBodyTd.closest('tr');
            const parentTbody = parentTr?.parentElement;

            if (parentTbody) {
                const allTrs = [...parentTbody.querySelectorAll(':scope > tr')];
                const whiteIndex = allTrs.indexOf(parentTr);
                const contentParts = [];
                let capturedAttrs = null;

                for (let i = whiteIndex + 1; i < allTrs?.length; i++) {
                    const tr = allTrs[i];
                    const trHtml = tr.innerHTML?.toLowerCase() || '';
                    const hasFooter = footerColors?.some(c => trHtml.includes(c.replace('#', '')));
                    if (hasFooter) break;

                    const tds = [...tr.querySelectorAll(':scope > td')].filter(td => {
                        if (isFooterTd(td)) return false;
                        const text = td.textContent?.trim() || '';
                        return text?.length > 2;
                    });

                    tds.forEach((td, idx) => {
                        if (idx === 0 && !capturedAttrs) {
                            capturedAttrs = captureAttrs(td); // ← full attrs
                        }
                        // contentParts.push(td.innerHTML.trim());
                        contentParts.push(`<div style="margin:0;padding:0;">${td.innerHTML.trim()}</div>`);
                    });
                }

                if (contentParts?.length > 0) {
                    bodyHTML = contentParts.join('');
                    originalAttrs = capturedAttrs;
                    // console.log('✅ Found content in sibling trs');
                }
            }
        }

        if (!bodyHTML || bodyHTML.trim()?.length < 5) {
            // console.log('❌ bodyHTML extraction failed');
            return newTemplate;
        }

        // console.log('✅ bodyHTML extracted, length:', bodyHTML.length);
        // console.log('✅ originalAttrs:', originalAttrs);

        // ── STEP 4: Find placeholder td in NEW template ───────────────────────
        const placeholderTd = [...newDoc.querySelectorAll('td')].find(td =>
            td.textContent?.trim() === 'Please enter your email text here.'
            && !td.querySelector('td')
        );

        if (!placeholderTd) {
            // console.log('❌ Placeholder td not found');
            return newTemplate;
        }

        // ── STEP 5: Inject — apply all original attrs ─────────────────────────
        placeholderTd.innerHTML = bodyHTML;
        if (originalAttrs) {
            applyAttrs(placeholderTd, originalAttrs); // ← style + align + valign + bgcolor
        }

        return newDoc.body.innerHTML;
    }

    useEffect(() => {

        // alert("second useffect inside")
        setComChanID(GetCommMediumData[0]?.commChannelId)

        // konsole.log("inblidinblidTextTemTextTemplate", inblidEmailTemplate[0]?.emailSubject)

        if (isTrueValue === true) {
            setfromRoleId(GetCommMediumData[0]?.commMediumRoles[0]?.fromRoleId)
            settoRoleId(GetCommMediumData[0]?.commMediumRoles[0]?.toRoleId)
        }

        // let valuedata = getChannelValue === "Email" ? "Email"
        //     : (getChannelValue === "Text") === "Text" ? "Text"
        //         : getChannelValue === "Both" === "Both" ? "Both" : ""

        form.setFieldsValue({
            "commChannel": getChannelValue?.value,
            // valuedata != (undefined||null||"")? valuedata : getChannelValue?.value,
            // "roleFrom": getSelectRoleFromValue ? getSelectRoleFromValue : "",
            // "asignRoleTo": getSelectRoleToValue ? getSelectRoleToValue : "",
            "emailsubject":
                getEmailTemplateSelect == false ? postOccurrence ||
                    GetCommMediumData[0]?.applicableEmailTempId == ("" || null || undefined) ? ""
                    : subjectEmailData :
                    subjectEmailData,
            // "emailckeditor": templateDataEdit


        })
        // setTemplateDataEdit(initialContent)


    }, [GetCommMediumData[0]?.commChannelId, GetCommMediumData[0]?.commMediumRoles, subjectEmailData, GetCommMediumData[0]?.commMediumRoles[0]?.fromRoleId, GetCommMediumData[0]?.commMediumRoles[0]?.toRoleId])



    konsole.log("khkuuuuuuuujhk", getChannelValue)

    const handleClose = () => {

        form.resetFields();
        setCreateNewButtonId(false)
        setChannelValue("")
        setName('');
        setSelectRoleFromValue([])
        setSelectRoleToValue([])
        setCreateValue(false)
        setShowDropDown(false)
        setCommMediumData(0)
        setuploadPreTempDropDown(false)
        props.setShowAddModal(false);
        getOccurrencefunction(subtenantID)
    }

    const handleTextUpdate = (e) => {
        // setTextMessage(e.target.value)
        // document.querySelector('.textarea_text').addEventListener('input', () => {
        //     var text = document.querySelector('.textarea_text').value;
        //     // document.querySelector('.textarea_text').value = text.charAt(0).toUpperCase() + text.slice(1);
        //     setTextMessage(document.querySelector('.textarea_text').value = text.charAt(0).toUpperCase() + text.slice(1))
        //     // setCkText(e)
        // })
        form.setFieldsValue(
            {
                addTextOnly: e.target.value
            }
        )
    }


    const onNameChange = (event) => {
        setName(event.target.value);
        // console.log("InputValue", name)
    };

    konsole.log("getOccurrenccurrenceSelect", getOccurrenceSelect)
    // ?.toLowerCase()?.includes(name)
    const addItem = (e) => {
        // konsole.log("item", items)
        e.preventDefault();
        let oldOccurenceName = getOccurrenceSelect?.filter(data => data?.occurrenceDetails === name)
        konsole.log("oldOccurenceNamegetOccurrenceSelect", oldOccurenceName)
        if (name === "") {
            message.error("Please enter occurrenc name")
            // alert("Please enter occurrenc name")
        }
        else if (oldOccurenceName[0]?.occurrenceDetails?.toLowerCase() == name?.toLowerCase()) {
            message.error("Occurrenc name allready exist")

            // alert("Occurrenc name allready exist")
        }
        else {
            setItems([...items, name || `New item ${index++}`]);
            setName('');
            setOpen(false)
            // items.push()
            // setTimeout(() => {
            //     inputRef.current?.focus();
            // }, 0);
            //    alert("tttttttttt")
            postOccurrenceData()
        }


    };


    const getCommonChannelValue = (value, key) => {
        setselect2(true)
        setChannelValue(key)
        // setComChanID(0)
        // setEmailSubject(null)
        if (key?.key == 1) {
            setSelectedChannelID(1)
            setSelectedChannelLinkID(1)
            setComChanID(1)
            setCkeditorIDEmail(0)
            setCkEditorID(0)
            // setuploadPreTempDropDown(false)
            form.setFieldsValue({

                "preDefineEmailTemplate": null,
                "emailsubject": ""

            })
        }
        else if (key?.key == 2) {
            setSelectedChannelID(2)
            setComChanID(2)
            setCkeditorIDEmail(0)
            setCkEditorID(0)
            // setuploadPreTempDropDown(false)

            form.setFieldsValue({
                "preDefineTextTemplate": null

            })
        }
        else if (key?.key == 3) {
            setSelectedChannelID(3)
            setSelectedChannelLinkID(3)
            setComChanID(3)
            // setuploadPreTempDropDown(false)

            form.setFieldsValue({
                "preDefineEmailTemplate": null,
                "preDefineTextTemplate": null

            })
        }
        else {
            // setSelectedChannelID(4)

        }
    }
    konsole.log("getChannelValuegetChannelValue", getChannelValue?.key)

    const getOccurrenceSelectedValueFunction = (value, key) => {
        setselect1(true)
        konsole.log(value)
        setOccurrenceSelectedValue(key)
        setOccuranceId(key?.key)
        if (key?.key !== undefined) {
            // alert("lkjlkjkljlkj")
            setShowSerchTrue(false)
        }
        else {
        }
    }

    const handleEmailTemplateChange = (value, key) => {
        konsole.log("dfysdf", key);
        setEmailTemplateSelect(true)
        setISDisabledInblidTemplate(true)
        konsole.log("printed");
        getEmailTemplatesPathApiFunction(subtenantID, key?.key);
    }

    // konsole.log("selectedChannelIDselectedChannelID", selectedChannelID, uploadPreTempDropDown, getChannelValue)

    const handleTextTemplateChange = (value, key) => {
        setTextTemplateSelect(true)
        setISDisabledInblidTemplate(true)
        getTextTemplatesPathApiFunction(subtenantID, key?.key);
        // GetCommMediumPathApiFuction(subtenantID, key?.key)
        if (selectedChannelID == 2) {
            setCkEditorID(2)

        }
        else if (selectedChannelID == 3) {
            setCkEditorID(3)
        }
        else {
            // setCkEditorID(4)
        }
    }

    const GetCommMediumPathApiFuction = (subtenantID, occuranceData) => {
        const promises = Services.GetCommMediumPathApi(subtenantID)
        promises.then((response) => {
            konsole.log("GetCommMediumPathApi", response?.data?.data);


            setCommMediumData1(response?.data?.data)
            newFunction(occuranceData, response.data.data);


        })
            .catch((error) => {
                konsole.log("error", error);
            })
            .finally(() => {
                konsole.log("finish");
            });

    };

    const newFunction = (getOccurrenceSelect, GetCommMediumData1) => {
        let i, j
        let occuranceData = getOccurrenceSelect;
        for (i = 0; i <= getOccurrenceSelect?.length - 1; i++) {
            for (j = 0; j <= GetCommMediumData1?.length - 1; j++) {
                if (getOccurrenceSelect[i]?.occurrenceId === GetCommMediumData1[j]?.occurrenceId) {
                    // setOccurrencNameIsTrue(true)
                    konsole.log("asdfgh", occuranceData[i]);
                    Object?.assign(occuranceData[i], { disabled: true });
                }
                else {
                    // setOccurrencNameIsTrue(false)

                }
            }

        }
        setOccurrenceSelect(occuranceData)

    }

    const createNewFunction = () => {
        //  e.preventDefault()

        if ((CreateNewButtonId != false && getChannelValue?.key == 1) || preDefineTemplateId == 1) {
            // alert("Email")
            postEmailTemplatesPathApi();
            setChannelValue(1)

        }
        else {
            if (uploadPreTempDropDown != true) {
                // alert("Email esle Part")
                setCreateNewButtonId(true)
            }

        }

        if ((CreateNewButtonId != false && getChannelValue?.key == 2 || getChannelValue == 2 || preDefineTemplateId == 2)) {
            // alert("Text")
            postTextTemplatesPathApi();
            setChannelValue(2)
        }
        else {
            // alert("Text Else Part")
            setCreateNewButtonId(true)
        }


        konsole.log("textMessagetextMessagetextMessagesadsadasdadasd", cktext)

        // if (cktext != "<p><br></p>" && cktext !== "" && cktext !== null && cktext !== undefined) {
        if ((CreateNewButtonId != false && getChannelValue?.key == 3 || (preDefineTemplateId == 1 && preDefineTemplateId == 2))) {
            // alert("Both")
            postEmailTemplatesPathApi();

        }
        else {
            setCreateNewButtonId(true)
        }

    }

    konsole.log("getChannelValue", getChannelValue)

    const handleFromRoleChange = (roleObj) => {
        setselect3(true)
        setRoleFromLength(0)
        setfromRoleId(0)
        setIsTrueValue(false)
        setISStopApi(true)

        const current = Array.isArray(getSelectRoleFromValue) ? getSelectRoleFromValue : [];
        const exists = current?.some(r => r.key === roleObj.key);
        const updated = exists
            ? current?.filter(r => r.key !== roleObj.key)
            : [...current, roleObj];

        setSelectRoleFromValue(updated);
        form.setFieldsValue({ roleFrom: updated?.length ? updated : undefined });
        setFromSearchText("");

        if (getSelectRoleToValue?.length > 0) {
            setSelectedFromID(2)
            setSelectedToID(2)
        } else {
            setSelectedToID(1)
        }
    };
    konsole.log("gjjkgkgkjgkkgkgkggkkkkkjgj", getSelectRoleFromValue?.key)


    const handleToRoleChange = (roleObj) => {
        setselect4(true)
        setRoleToLength(0)
        settoRoleId(0)
        setISStopApi(true)

        const current = Array.isArray(getSelectRoleToValue) ? getSelectRoleToValue : [];
        const exists = current?.some(r => r.key === roleObj.key);
        const updated = exists
            ? current?.filter(r => r.key !== roleObj.key)
            : [...current, roleObj];

        setSelectRoleToValue(updated);
        form.setFieldsValue({ asignRoleTo: updated?.length ? updated : undefined });
        setToSearchText("");

        if (getSelectRoleFromValue?.length > 0) {
            setSelectedToID(2)
            setSelectedFromID(2)
        } else {
            setSelectedFromID(1)
        }
    }


    const getValueSubjectInput = (e) => {
        setEmailSubjectValue(e?.target?.value)

    }

    const showContentfunction = () => {
        // alert("not requi func call")
        // form.submit()

        if ((selectedChannelID == 1) || (selectedChannelID == 2) || (selectedChannelID == 3)) {
            setuploadPreTempDropDown(true)
            getPreEmailTemplatesPathApiFunction(subtenantID)
            getPreTextTemplatesPathApiFunction(subtenantID)
            // setCreateNewButtonId(false)
        }


    }

    konsole.log("klhlkhhklhlhklhhlh", getEmailSubjectValue)

    //Api Code
    const getCommonChannelfunction = () => {
        const promises = Services.getCommonChannelApi()
        promises.then((response) => {
            // konsole.log("resssress", response);
            setCommonChannelSelect(response.data.data);

        })
            .catch((error) => {
                konsole.log("error", error);
            })
            .finally(() => {
                konsole.log("finish");
            });
    };

    const getUserRolesfunction = () => {
        const promises = Services.getUSerRolesAdminApi()
        promises.then((response) => {
            // konsole.log("resssress", response);
            const rawRoles = response?.data?.data || [];
            const uniqueRoles = rawRoles?.filter(
                (role, index, self) =>
                    index === self?.findIndex(r => r.label === role.label)
            );
            setUserRoleSelect(uniqueRoles);

        })
            .catch((error) => {
                konsole.log("error", error);
            })
            .finally(() => {
                konsole.log("finish");
            });
    };



    const getEmailTemplatesPathApiFunction = (subtenantID, emailID) => {
        const resultEmailTemplate = getSelectedEmailTemplateData.filter(element => element.templateId == emailID);
        if (resultEmailTemplate?.length == 0) return;

        const oldContent = resultEmailTemplate[0]?.templateContent;

        // ✅ merge: take body from OLD, put into NEW template (initialContent)
        const mergedContent = mergeEmailTemplates(oldContent, templateDataEdit); // ← use templateDataEdit not initialContent
        setInblidEmailTemplate(mergedContent); // ✅ no replaceTemplate needed, already replaced
        setSubjectEmailData(resultEmailTemplate[0]?.emailSubject);
        setCreateLinkState(true);
        setSelectedChannelLinkID(0);
        form.setFieldsValue({
            emailsubject: resultEmailTemplate[0]?.emailSubject,
        });

        if (selectedChannelID == 1) setCkEditorID(1);
        else if (selectedChannelID == 2) setCkEditorID(2);
        else if (selectedChannelID == 3) setCkeditorIDEmail(3);
        else setCkEditorID(4);

        if (uploadPreTempDropDown == true) setPreDefineTemplateId(1);
    };

    konsole.log('inblidinblidEmailTemplatedEmaatejlkjkl', inblidEmailTemplate)


    const getPreEmailTemplatesPathApiFunction = (subtenantID) => {
        // alert(subtenantID,emailID)
        // konsole.log("subtenanlkjlj", subtenantID, emailID)

        const promises = Services.getEmailTemplatesPathApi(config.SUBTENANT_ID)
        promises.then((response) => {
            konsole.log("preEmailTemplatesData", response?.data?.data);
            // setInblidEmailTemplate(response?.data?.data);
            setSelectedEmailTemplateData(response?.data?.data)

        })
            .catch((error) => {
                konsole.log("error", error);
            })
            .finally(() => {
                konsole.log("finish");
            });
    };


    const getTextTemplatesPathApiFunction = (subtenantID, id) => {
        // konsole.log("subtenanlkjljkhkh", subtenantID, id)
        const resultTextTemplate = getSelectedTextTemplateData.filter(element => element.textTemplateId == id);
        if (resultTextTemplate?.length == 0) return;
        setInblidTextTemplate(resultTextTemplate);
        setTextMessage(resultTextTemplate[0]?.textTemplateContent)
        setCreateLinkState(true)
        setSelectedChannelLinkID(0)
        form.setFieldsValue(
            {
                addTextOnly: resultTextTemplate[0]?.textTemplateContent
            }
        )

        if (uploadPreTempDropDown == true) {
            setPreDefineTemplateId(2)
            // setCkText(response?.data?.data[0]?.textTemplateContent)
        }

    };

    const getPreTextTemplatesPathApiFunction = (subtenantID) => {
        // konsole.log("subtenanlkjljkhkh", )

        const promises = Services.getTextTemplatesPathApi(config.SUBTENANT_ID)
        promises.then((response) => {
            konsole.log("TextTemplatesDatalkllllllllllllllkllll", response.data.data);
            setSelectedTextTemplateData(response?.data?.data)
            // form.setFieldsValue(
            //     {
            //         addTextOnly: response.data?.data[0]?.textTemplateContent
            //     }
            // )
        })
            .catch((error) => {
                konsole.log("error", error);
            })
            .finally(() => {
                konsole.log("finish");
            });
    };

    konsole.log("getSelecTextTemplateuuuDatiia", form.getFieldValue().addTextOnly)

    const getOccurrencefunction = (subtenantID) => {
        const promises = Services.getOccurrenceApi()
        promises.then((response) => {
            konsole.log("resssress", response.data.data);
            setItems(response.data.data);
            setOccurrenceSelect(response.data.data)
            GetCommMediumPathApiFuction(subtenantID, response.data.data)

        })
            .catch((error) => {
                konsole.log("error", error);
            })
            .finally(() => {
                konsole.log("finish");
            });
    }

    // konsole.log("getOccurrencjljljeSelect", getOccurrenceSelect.length)



    const postOccurrenceData = () => {

        const promises = Services.postUpsertOccurrenceApi(0, name, true, userId)
        promises.then((response) => {
            // konsole.log("ressresssresssress", response);
            setItems(response.data.data);
            setPostOccurrence(response.data.data)
            // setOccuranceName()
            form.setFieldsValue({
                "occurrence": response.data.data?.occurrenceDetails
            })
            message.success("Occurrenc name add successfully")
            setChannelValue("")
            setSelectRoleFromValue("")
            setSelectRoleToValue("")
            setCommMediumData("")
            setCreateValue(false)
            setCreateNewButtonId(false)
            setOccurrenceSelectedValue(0)
            getOccurrencefunction(subtenantID);

        })
            .catch((error) => {
                konsole.log("error", error);
            })
            .finally(() => {
                konsole.log("finish");
            });



    };


    const postEmailTemplatesPathApi = () => {

        let jsonObj = {
            "templateType": postOccurrence?.occurrenceDetails ? postOccurrence?.occurrenceDetails : getOccurrenceSelectedValue?.value,
            "emailSubject": getEmailSubjectValue ? getEmailSubjectValue : subjectEmailData,
            "templateContent": document.getElementById("testAreaId").innerHTML,
            // templateDataEdit,
            "isActive": true,
            "createdBy": userId
        }

        let strValue = JSON.stringify(jsonObj)
        konsole.log("strValue", strValue)
        konsole.log("emailobj", jsonObj)

        const promises = Services.postEmailTemplatesPathApi(postOccurrence?.occurrenceDetails ? postOccurrence?.occurrenceDetails : getOccurrenceSelectedValue?.value, getEmailSubjectValue ? getEmailSubjectValue : subjectEmailData, document?.getElementById("testAreaId")?.innerHTML, true, userId)
        promises.then((response) => {
            konsole.log("resporesponsense", response?.data?.data);
            setPostCkEditorEmail(response.data.data);

            if (getChannelValue?.key == 1 || getChannelValue == 1) {

                postUpsertCommMediumApiFuction(response.data.data?.templateId);
            }
            else {

                postTextTemplatesPathApi(response.data.data?.templateId, "both");


            }

        })
            .catch((error) => {
                konsole.log("errorpostEmailTemplatesPathApi", error);
            })
            .finally(() => {
                konsole.log("finish");
            });

    }

    konsole.log("postCkEditorEmail", postCkEditorEmail);

    const postTextTemplatesPathApi = (EmailId, type) => {

        if (form.getFieldValue().addTextOnly !== "" && form.getFieldValue().addTextOnly !== null && form.getFieldValue().addTextOnly !== undefined) {
            // alert("data having")
            let jsonObj = {
                "textTemplateId": 0,
                "textTemplateType": getOccurrenceSelectedValue?.value,
                // "textSubject": postOccurrence?.occurrenceDetails ? postOccurrence?.occurrenceDetails : getOccurrenceSelectedValue?.value,
                "textTemplateContent": form.getFieldValue().addTextOnly,
                "isActive": true,
                "upsertedBy": userId
            }

            let strValue = JSON.stringify(jsonObj)
            // konsole.log("textobj", strValue)

            const promises = Services.postTextTemplatesPathApi(
                0,
                postOccurrence?.occurrenceDetails ? postOccurrence?.occurrenceDetails : getOccurrenceSelectedValue?.value,
                form.getFieldValue().addTextOnly,
                true,
                userId
            )

            promises.then((response) => {
                // konsole.log("postTextTemplatesPathApi", response)
                setPostCkEditorText(response.data.data)

                if (getChannelValue?.key == 2 || getChannelValue == 2) {
                    // alert("inside text")
                    postUpsertCommMediumApiFuction(response.data.data?.textTemplateId);

                }
                else {
                    postUpsertCommMediumApiFuction(EmailId, response.data.data?.textTemplateId);

                }

            })
                .catch((error) => {
                    konsole.log("errorpostTextTemplatesPathApi", error);
                })
                .finally(() => {
                    konsole.log("finish");
                    if (type == "both") {
                        setChannelValue(3)
                    }
                });


        } else {
            message.error("Please Fill the text")
        }




    };

    // konsole.log("postCkEditorTextpostCkEditorText", templateDataEdit)

    const postUpsertCommMediumApiFuction = (templateId, textTempId) => {



        let arr = [];
        let i, j;

        for (i = 0; i <= getSelectRoleFromValue?.length - 1; i++) {
            for (j = 0; j <= getSelectRoleToValue?.length - 1; j++) {

                arr.push(
                    {
                        "commMediumRolesId": 0,
                        "fromRoleId": getSelectRoleFromValue[i]?.key,
                        "toRoleId": getSelectRoleToValue[j]?.key,
                        "isActive": true
                    }
                )
            }
        }
        konsole.log("arayfir", arr)

        let obj = (getChannelValue?.key == 3) && (templateId && textTempId) || getChannelValue == 3 && (templateId && textTempId) ? {
            "commMediumId": 0,
            "commChannelId": getChannelValue?.key,
            "subtenantId": subtenantID,
            "applicableEmailTempId": templateId,
            "applicableTextTempId": textTempId,
            "occurrenceId": postOccurrence?.occurrenceId ? postOccurrence?.occurrenceId : getOccurrenceSelectedValue?.key,
            "isActive": true,
            "upsertedBy": userId,
            "commMediumRoles": arr
        }
            : getChannelValue?.key == 2 && templateId || getChannelValue == 2 && templateId ? {

                "commMediumId": 0,
                "commChannelId": getChannelValue?.key,
                "subtenantId": subtenantID,
                // "applicableEmailTempId": postCkEditorEmail?.templateId ? postCkEditorEmail?.templateId : "",
                "applicableTextTempId": templateId,
                "occurrenceId": postOccurrence?.occurrenceId ? postOccurrence?.occurrenceId : getOccurrenceSelectedValue?.key,
                "isActive": true,
                "upsertedBy": userId,
                "commMediumRoles": arr
            }
                : getChannelValue?.key == 1 && templateId || getChannelValue == 1 && templateId ? {
                    "commMediumId": 0,
                    "commChannelId": getChannelValue?.key,
                    "subtenantId": subtenantID,
                    "applicableEmailTempId": templateId,
                    // "app(licableTextTempId": postCkEditorText?.textTemplateId ? postCkEditorText?.textTemplateId : null,
                    "occurrenceId": postOccurrence?.occurrenceId ? postOccurrence?.occurrenceId : getOccurrenceSelectedValue?.key,
                    "isActive": true,
                    "upsertedBy": userId,
                    "commMediumRoles": arr
                } : {}

        konsole.log("objobjobjobj", obj)
        setLoader(true)

        const promises = Services.postUpsertCommMediumApi(obj)
        promises.then((response) => {
            konsole.log("responseresponse", response.data.data);
            setPostAllData(response.data.data)
            // setTemplateDataEdit("")
            setCkText("")
            getPreEmailTemplatesPathApiFunction(subtenantID)
            getPreTextTemplatesPathApiFunction(subtenantID)
            props.GetCommMediumPathApiFuction()

            handleClose()
            setLoader(false)
            // window.location.reload()

        })
            .catch((error) => {
                konsole.log("errorerrorerror", error);
            })
            .finally(() => {
                konsole.log("finish post api");
                setLoader(false)

                // konsole.log(props.GetCommMediumPathApiFuction(), "GetCommMediumPathApiFuction")

            });

    }


    konsole.log("callpostAllData", callpostAllData)




    // End api code

    const fromRoleNameFuction = (data) => {

        let arrData = [], newArr = [];

        arrData.push(data);

        konsole.log("formarrData", arrData)

        for (let i = 0; i <= arrData[0]?.length - 1; i++) {
            newArr.push(arrData[0]?.[i]?.fromRoleName)

        }

        for (let k = 1; k <= [...new Set(newArr)]?.length; k++) {
            setRoleFromLength(k);

        }
        return [...new Set(newArr)]

    }


    const ToRoleNameFuction = (data) => {
        // console.log("NewDaata", data)
        let arrData = [], newArr = [];

        arrData.push(data);
        // console.log("arrDataarrDataarrDataarrData", arrData[0]?.[3]?.fromRoleId)

        for (let i = 0; i <= arrData[0]?.length - 1; i++) {

            //   console.log("arrDataarrDataarrDataarrData", arrData[0]?.[i]?.toRoleName)
            newArr.push(arrData[0]?.[i]?.toRoleName)
        }
        // console.log("NewArrayArrayNewArray", newArr)

        for (let q = 1; q <= [...new Set(newArr)]?.length; q++) {

            setRoleToLength(q);

        }
        // konsole.log("toroletorole", [...new Set(newArr)])

        return [...new Set(newArr)]

    }
    // konsole.log("onfinsh", selectedChannelID, getOccurrenceSelectedValue?.key, postOccurrence)

    const onFinish = (e) => {
        // alert("finish")

        if ((selectedChannelID == 1 || selectedChannelID == 2 || selectedChannelID == 3) && (getOccurrenceSelectedValue?.key || postOccurrence)) {
            // alert("finish if")
            createNewFunction()

        }
        else {
            // alert("finish else")
        }

        konsole.log("eeeeeeeeeeeeesgdgh", e)
    }

    const getChangeDataOfEditor = (e) => {
        setTemplateDataEdit(e.target.value)
    }
    konsole.log("uuuuuuuaEdittemplateDataEdit", templateDataEdit)

    const selectFuction = (visible) => {
        setOpen(visible)
        if (visible && getOccurrenceSelectedValue?.key != undefined) {
            setShowSerchTrue(true)
        }
    }

    let linkButton = document.getElementById("createLink");

    const modifyText = (command, defaultUi, value) => {
        //execCommand executes command on selected text
        konsole.log("point here", command, defaultUi, value);
        document.execCommand(command, defaultUi, value)
        // setCreateLinkState(true)


    };


    const linkCreateButtonFunction = () => {
        const selection = window.getSelection();
        if (!selection.rangeCount || selection.toString().trim() === "") {
            message.error("Please select some text first");
            return;
        }
        const savedRange = selection.getRangeAt(0).cloneRange(); // ✅ selection save kar liya

        let userLink = prompt("Enter a URL");
        if (!userLink) return;

        if (!/^https?:\/\//i.test(userLink)) {
            userLink = "http://" + userLink;
        }

        // ✅ selection restore karo prompt ke baad
        selection.removeAllRanges();
        selection.addRange(savedRange);

        document.execCommand("createLink", false, userLink);
    };


    return (
        <div>
            <Modal
                centered={true}
                className="Modal-Main-Class"
                visible={props?.showAddModal}
                footer={false}
                onCancel={handleClose}
                closable={false}
                maskClosable={false}
                size="xl"
                enforceFocus={false}
                width={1000}
                style={{ top: 20 }}
                bodyStyle={{ padding: '0px', borderRadius: '8px' }}>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 8px 12px 16px', borderBottom: '1px solid #bfbfbf' }}>
                    <p style={{ fontSize: '16px', fontWeight: '700', color: '#333333', margin: 0 }}>
                        Add Content
                    </p>
                    <span onClick={handleClose} style={{ cursor: 'pointer', fontSize: '25px', color: '#333333', lineHeight: 1, padding: '2px 6px' }}>×</span>
                </div>
                <Form form={form} name="useForm" onFinish={onFinish} onFinishFailed={(data) => konsole.log("errorin on Finsin", data)}
                    style={{ maxHeight: 'calc(100vh - 80px)', overflowY: 'auto', padding: "8px 16px 16px 16px" }}>
                    <Row >
                        <Col span={24}>

                            <Row className="mt-2">
                                <Col span={24} xs={24} sm={24} md={24} lg={24} >
                                    <h5 style={{ marginLeft: "1px" }}>Occurrence</h5>
                                    <Form.Item
                                        name="occurrence"

                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select Occurrence"
                                            }
                                        ]}>

                                        <Select
                                            className='SeminarRegistrationSelect Select-input'
                                            placeholder="Select a Occurrence"
                                            open={open}
                                            onChange={getOccurrenceSelectedValueFunction}
                                            onDropdownVisibleChange={(visible) => selectFuction(visible)
                                            }
                                            listHeight={90}
                                            defaultOpen={true}
                                            showSearch={showSerchTrue}
                                        >
                                            {
                                                getOccurrenceSelect?.filter(data => data?.occurrenceDetails?.toLowerCase().includes(name.toLowerCase()))?.map((item) => (
                                                    <option value={item?.occurrenceDetails} key={item?.occurrenceId} disabled={item.disabled}
                                                    >{item?.occurrenceDetails}</option>

                                                ))
                                            }
                                        </Select>

                                    </Form.Item>

                                </Col>

                                {konsole.log("getOccurrenceSelect", OccurrencNameIsTrue)}
                            </Row>

                            <Row className='mt-2' gutter={[16, 0]}>
                                <Col span={8} xs={24} sm={24} md={8} lg={8}>
                                    <h5 style={{ marginLeft: "1px" }}>Communication Channel</h5>
                                    <Form.Item
                                        className='mb-0'
                                        name="commChannel"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select channel"
                                            }
                                        ]}>
                                        <Select size='sm'
                                            className='commChannelSelect'
                                            listHeight={100}
                                            onChange={getCommonChannelValue}
                                            placeholder="Communication Channel"
                                            style={{ width: "100%" }}
                                            open={openChannelDropdown}
                                            onDropdownVisibleChange={(visible) => setOpenChannelDropdown(visible)}
                                            suffixIcon={
                                                <img
                                                    src="/black_select.svg"
                                                    style={{
                                                        height: 16, width: 12,
                                                        transition: "transform 0.2s",
                                                        transform: openChannelDropdown ? "rotate(180deg)" : "rotate(0deg)"
                                                    }}
                                                    alt=""
                                                />
                                            }
                                        >
                                            {commonChannelSelect?.map((data) => (

                                                <option value={data?.label} key={data?.value}>{data?.label}</option>

                                            ))}

                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={8} xs={24} sm={24} md={8} lg={8} >
                                    <h5 style={{ marginLeft: "1px" }}>From</h5>
                                    <Form.Item
                                        name="roleFrom"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select Role"
                                            }
                                        ]}
                                        className="asignRoleTo-col role-select-wrapper m-0 pb-2 mb-0"
                                        getValueProps={() => ({ value: getSelectRoleFromValue || [] })}
                                    >
                                        <div ref={fromDropdownRef} style={{ position: "relative" }}>
                                            <div
                                                onClick={() => setOpenFromDropdown(!openFromDropdown)}
                                                style={{
                                                    border: "1px solid #474747", padding: "4px 8px", borderRadius: 2,
                                                    display: "flex", alignItems: "center", gap: 4,
                                                    cursor: "text", background: "#fff", fontSize: 14, height: "44px",
                                                    overflow: "hidden"
                                                }}
                                            >
                                                {(() => {
                                                    const selected = Array.isArray(getSelectRoleFromValue) ? getSelectRoleFromValue : [];
                                                    if (!selected?.length) return null;
                                                    return (
                                                        <>
                                                            <span style={{
                                                                background: "#f0f0f0", border: "1px solid #d9d9d9", borderRadius: 4,
                                                                padding: "2px 6px", fontSize: 13, color: "#333", display: "flex",
                                                                alignItems: "center", gap: 4, whiteSpace: "nowrap", flexShrink: 0
                                                            }}>
                                                                {selected[0]?.value}
                                                                <span
                                                                    onClick={(e) => { e.stopPropagation(); handleFromRoleChange(selected[0]); }}
                                                                    style={{ cursor: "pointer", fontWeight: "bold" }}
                                                                >×</span>
                                                            </span>
                                                            {selected?.length > 1 && (
                                                                <span style={{
                                                                    background: "#f0f0f0", border: "1px solid #d9d9d9", borderRadius: 4,
                                                                    padding: "2px 6px", fontSize: 13, color: "#333", whiteSpace: "nowrap", flexShrink: 0
                                                                }}>
                                                                    +{selected?.length - 1}
                                                                </span>
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                                <input
                                                    type="text"
                                                    value={fromSearchText}
                                                    onChange={(e) => { setFromSearchText(e.target.value); setOpenFromDropdown(!openFromDropdown); }}
                                                    onFocus={() => setOpenFromDropdown(true)}
                                                    placeholder={(Array.isArray(getSelectRoleFromValue) && getSelectRoleFromValue?.length) ? "" : "Select a role"}
                                                    style={{
                                                        border: "none", outline: "none", flex: 1, minWidth: 30, fontSize: 14,
                                                        background: "transparent", boxShadow: "none", padding: 0, borderRadius: 0,
                                                        height: "24px",
                                                        cursor: "pointer"
                                                    }}
                                                />
                                                <span style={{ display: "inline-block", transition: "transform 0.2s", transform: openFromDropdown ? "rotate(180deg)" : "rotate(0deg)", flexShrink: 0,cursor: "pointer",cusor: "pointer" }}>
                                                    <img src="/black_select.svg" style={{ height: 16, width: 12 }} alt="" />
                                                </span>
                                            </div>
                                            {openFromDropdown && (
                                                <div style={{
                                                    position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0,
                                                    background: "#fff", border: "1px solid #d9d9d9", borderRadius: 6,
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 1000,
                                                    maxHeight: 200, overflowY: "auto", padding: "4px 0"
                                                }}>
                                                    {getUserRoleSelect?.filter(roleItem => roleItem.label.toLowerCase().includes(fromSearchText.toLowerCase()))?.map(roleItem => {
                                                            const selectedArr = Array.isArray(getSelectRoleFromValue) ? getSelectRoleFromValue : [];
                                                            const isChecked = selectedArr?.some(r => r.key === roleItem.value);
                                                            return (
                                                                <div key={roleItem.value} className="comm-role-dropdown-item">
                                                                    <label style={{
                                                                        display: "flex", alignItems: "center", gap: 8,
                                                                        cursor: "pointer", fontSize: 14, padding: "6px 12px", margin: 0
                                                                    }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{ height: "16px", width: "16px" }}
                                                                            checked={isChecked}
                                                                            onChange={() => handleFromRoleChange({ key: roleItem.value, value: roleItem.label })}
                                                                        />
                                                                        {roleItem.label}
                                                                    </label>
                                                                </div>
                                                            );
                                                        })}

                                                    {getUserRoleSelect?.filter(roleItem => roleItem.label.toLowerCase().includes(fromSearchText.toLowerCase()))?.length === 0 && (
                                                        <div style={{ padding: "8px 12px", fontSize: 13, color: "#999" }}>No roles found</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </Form.Item>
                                </Col>
                                <Col span={8} xs={24} sm={24} md={8} lg={8}>
                                    <h5 style={{ marginLeft: "1px" }}>To</h5>
                                    <Form.Item
                                        name="asignRoleTo"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select Asign Role"
                                            }
                                        ]}
                                        className="asignRoleTo-col role-select-wrapper m-0 pb-4"
                                        getValueProps={() => ({ value: getSelectRoleToValue || [] })}
                                    >
                                        <div ref={toDropdownRef} style={{ position: "relative" }}>
                                            <div
                                                onClick={() => setOpenToDropdown(!openToDropdown)}
                                                style={{
                                                    border: "1px solid #474747", padding: "4px 8px", borderRadius: 2,
                                                    display: "flex", alignItems: "center", gap: 4,
                                                    cursor: "text", background: "#fff", fontSize: 14, height: "44px",
                                                    overflow: "hidden"
                                                }}
                                            >
                                                {(() => {
                                                    const selected = Array.isArray(getSelectRoleToValue) ? getSelectRoleToValue : [];
                                                    if (!selected?.length) return null;
                                                    return (
                                                        <>
                                                            <span style={{
                                                                background: "#f0f0f0", border: "1px solid #d9d9d9", borderRadius: 4,
                                                                padding: "2px 6px", fontSize: 13, color: "#333", display: "flex",
                                                                alignItems: "center", gap: 4, whiteSpace: "nowrap", flexShrink: 0
                                                            }}>
                                                                {selected[0]?.value}
                                                                <span
                                                                    onClick={(e) => { e.stopPropagation(); handleToRoleChange(selected[0]); }}
                                                                    style={{ cursor: "pointer", fontWeight: "bold" }}
                                                                >×</span>
                                                            </span>
                                                            {selected?.length > 1 && (
                                                                <span style={{
                                                                    background: "#f0f0f0", border: "1px solid #d9d9d9", borderRadius: 4,
                                                                    padding: "2px 6px", fontSize: 13, color: "#333", whiteSpace: "nowrap", flexShrink: 0
                                                                }}>
                                                                    +{selected?.length - 1}
                                                                </span>
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                                <input
                                                    type="text"
                                                    value={toSearchText}
                                                    onChange={(e) => { setToSearchText(e.target.value); setOpenToDropdown(!openToDropdown); }}
                                                    onFocus={() => setOpenToDropdown(true)}
                                                    placeholder={(Array.isArray(getSelectRoleToValue) && getSelectRoleToValue?.length) ? "" : "Select a role"}
                                                    style={{
                                                        border: "none", outline: "none", flex: 1, minWidth: 30, fontSize: 14,
                                                        background: "transparent", boxShadow: "none", padding: 0, borderRadius: 0,
                                                        height: "24px",
                                                        cursor: "pointer"
                                                    }}
                                                />
                                                <span style={{ display: "inline-block", transition: "transform 0.2s", transform: openToDropdown ? "rotate(180deg)" : "rotate(0deg)", flexShrink: 0,cursor: "pointer" }}>
                                                    <img src="/black_select.svg" style={{ height: 16, width: 12 }} alt="" />
                                                </span>
                                            </div>
                                            {openToDropdown && (
                                                <div style={{
                                                    position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0,
                                                    background: "#fff", border: "1px solid #d9d9d9", borderRadius: 6,
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 1000,
                                                    maxHeight: 200, overflowY: "auto", padding: "4px 0"
                                                }}>
                                                    {getUserRoleSelect?.filter(roleItem => roleItem.label.toLowerCase().includes(toSearchText.toLowerCase()))
                                                        ?.map(roleItem => {
                                                            const selectedArr = Array.isArray(getSelectRoleToValue) ? getSelectRoleToValue : [];
                                                            const isChecked = selectedArr?.some(r => r.key === roleItem.value);
                                                            return (
                                                                <div key={roleItem.value} className="comm-role-dropdown-item">
                                                                    <label style={{
                                                                        display: "flex", alignItems: "center", gap: 8,
                                                                        cursor: "pointer", fontSize: 14, padding: "6px 12px", margin: 0
                                                                    }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{ height: "16px", width: "16px" }}
                                                                            checked={isChecked}
                                                                            onChange={() => handleToRoleChange({ key: roleItem.value, value: roleItem.label })}
                                                                        />
                                                                        {roleItem.label}
                                                                    </label>
                                                                </div>
                                                            );
                                                        })}

                                                    {getUserRoleSelect?.filter(roleItem => roleItem.label.toLowerCase().includes(toSearchText.toLowerCase()))?.length === 0 && (
                                                        <div style={{ padding: "8px 12px", fontSize: 13, color: "#999" }}>No roles found</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </Form.Item>
                                </Col>
                            </Row>


                            <ModalBody className='Modal-Body-Add-Modal'>
                                {
                                    (uploadPreTempDropDown == true && selectedChannelID == 3)
                                        ?
                                        <div>
                                            <Row className='d-flex justify-content-between mb-1' style={{ marginRight: "5px" }}>
                                                <Col span={11} md={24}>
                                                    <h5>Text Template</h5>
                                                    <Form.Item
                                                        name="preDefineTextTemplate"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please select text template"
                                                            }
                                                        ]}>
                                                        <Select size='sm' className='w-100'
                                                            onChange={handleTextTemplateChange}
                                                            placeholder="Select pre define text template "
                                                            showSearch
                                                            listHeight={100}
                                                        >

                                                            {getSelectedTextTemplateData?.map((item) => (
                                                                <option value={item?.textTemplateType} key={item?.textTemplateId}>{item?.textTemplateType}</option>

                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                    {
                                                        (uploadPreTempDropDown == true && selectedChannelID == 3 && getChannelValue?.key == 3 && ckeditorID == 3)
                                                        &&
                                                        <div>
                                                            <Row >
                                                                <Col span={24}>
                                                                    <Row className='d-flex justify-content-between'>

                                                                        <Col className='' span={24} xs={24} sm={24} md={24} lg={24}>
                                                                            <h5>Text</h5>

                                                                            <div className='mt-2 w-100'>
                                                                                <AtTheRateTextArea id="textAreaAt1" className="w-100" rows="4" handleTextUpdate={handleTextUpdate} occuranceId={occuranceId} defaultText={textMessage} placeholder="" />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    }
                                                </Col>
                                                <Col span={11} md={24} className="mt-3">
                                                    <h5>Email Template</h5>
                                                    <Form.Item
                                                        name="preDefineEmailTemplate"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please select email template"
                                                            }
                                                        ]}>
                                                        <Select size='sm' className='w-100'
                                                            onChange={handleEmailTemplateChange}
                                                            listHeight={100}
                                                            placeholder="Select pre define email template "
                                                            showSearch

                                                        >
                                                            {getSelectedEmailTemplateData?.map((item) => (
                                                                <option value={item?.templateType} key={item?.templateId} >{item?.templateType}</option>

                                                            ))}
                                                        </Select>
                                                    </Form.Item>

                                                    {
                                                        (uploadPreTempDropDown == true && selectedChannelID == 3 && getChannelValue?.key == 3 && ckeditorIDEmail == 3)

                                                        &&
                                                        <>
                                                            <h5>Email</h5>
                                                            <div className='mb-2'>
                                                                <Form.Item
                                                                    name="emailsubject"
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Please Enter email subject"
                                                                        }
                                                                    ]}>
                                                                    <Input placeholder="Enter Email Subject"
                                                                        onChange={getValueSubjectInput}
                                                                        onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)}


                                                                    />
                                                                </Form.Item>
                                                            </div>


                                                            <div className='d-flex justify-content-center email-editor-wrapper'>
                                                                <div placeholder='enter your data'

                                                                    style={{ border: "1px solid grey", width: "100%" }}
                                                                    id="testAreaId" rows={20} contenteditable="true" dangerouslySetInnerHTML={{
                                                                        __html:
                                                                            (uploadPreTempDropDown == true) ? inblidEmailTemplate : templateDataEdit

                                                                    }}>
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                </Col>
                                            </Row>
                                        </div>

                                        :
                                        (uploadPreTempDropDown == true && selectedChannelID == 1)
                                            ?
                                            <>
                                                <Row className='d-flex justify-content-between '>
                                                    <Col span={11} md={24} lg={24} >
                                                        <h5>Email Template</h5>
                                                        <Form.Item
                                                            name="preDefineEmailTemplate"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Please select email template"
                                                                }
                                                            ]}>
                                                            <Select size='sm' className='w-100'
                                                                onChange={handleEmailTemplateChange}
                                                                listHeight={100}
                                                                placeholder="Select pre define email template "
                                                                showSearch
                                                            >
                                                                {getSelectedEmailTemplateData?.length > 0 && getSelectedEmailTemplateData?.map((data, index) => (
                                                                    <option value={data?.templateType} key={data?.templateId}>{data?.templateType}</option>

                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                </Row>
                                            </>

                                            :
                                            (uploadPreTempDropDown == true && selectedChannelID == 2)

                                                ?
                                                <>
                                                    <Row className='d-flex justify-content-between'>
                                                        <Col span={11} md={24} lg={24}>
                                                            <h5>Text Template</h5>
                                                            <Form.Item
                                                                name="preDefineTextTemplate "
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please select text template"
                                                                    }
                                                                ]}>
                                                                <Select size='sm' className='w-100'
                                                                    onChange={handleTextTemplateChange}
                                                                    listHeight={100}
                                                                    placeholder="Select pre define text template "
                                                                    showSearch
                                                                >
                                                                    {getSelectedTextTemplateData?.map((item) => (
                                                                        <option value={item?.textTemplateType} key={item?.textTemplateId}>{item?.textTemplateType}</option>

                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </>

                                                :
                                                ""

                                }

                                {
                                    (getChannelValue?.key == 3 && CreateNewButtonId === true && uploadPreTempDropDown == false && comChanID == 3)

                                        ?
                                        <div style={{ marginRight: "5px" }}>
                                            <Row >
                                                <Col span={24}>
                                                    <Row className='d-flex justify-content-between'>

                                                        <Col className='' span={24} xs={24} sm={24} md={24} lg={24}>
                                                            <h5>SMS-Text</h5>
                                                            <div className='mt-2 w-100'>
                                                                <AtTheRateTextArea id="textAreaAt2" className="textarea_text w-100" rows="4" handleTextUpdate={handleTextUpdate} occuranceId={occuranceId} defaultText="" placeholder="" />
                                                            </div>
                                                        </Col>

                                                        <Col span={24} className="d-flex justify-content-end mt-2 " style={{ position: "sticky", top: " 10px", zIndex: "1" }}>
                                                            <div className={createLinkState == true && getChannelValue?.key == 1 && inblidEmailTemplate?.length == 0 ? 'show-link-with-pre-temp' : uploadPreTempDropDown == true && getChannelValue?.key == 1 && selectedChannelLinkID == 1 ? "show-link-with-pre-temp2" :
                                                                uploadPreTempDropDown == true && getChannelValue?.key == 3 && selectedChannelLinkID == 3 ? "show-link-with-pre-temp3" :
                                                                    uploadPreTempDropDown == true && getChannelValue?.key == 3 && inblidEmailTemplate?.length > 0 ? "show-link-with-pre-temp4" :
                                                                        ''}>

                                                                {getChannelValue?.key == 1 && CreateNewButtonId == true || getChannelValue?.key == 3 && CreateNewButtonId == true
                                                                    || createLinkState == true && getChannelValue?.key == 1 || createLinkState == true && getChannelValue?.key == 3
                                                                    ?

                                                                    <div style={{ width: "41px", height: "35px", marginRight: "10px" }} className=" "
                                                                        onMouseLeave={() => { document.querySelector(".linkicons").style.transform = "scale(1)" }}
                                                                    >
                                                                        <button id="createLink" className="adv-option-button mt-1 "
                                                                            onClick={linkCreateButtonFunction}
                                                                            disabled={isDisabled}
                                                                            style={{ backgroundColor: "white", float: "right", cursor: "pointer", border: "none", }}>
                                                                            <img src="images/link5.jpg" className='img-fluid linkicons' style={{ opacity: ".7" }}

                                                                                onMouseEnter={() => { document.querySelector(".linkicons").style.transform = "scale(1.1)" }}
                                                                            />

                                                                        </button>
                                                                    </div>
                                                                    : ""}
                                                            </div>
                                                        </Col>

                                                        <Col span={24} xs={24} sm={24} md={24} lg={24} className="">
                                                            <h5>Email</h5>
                                                            <div className='mb-2'>
                                                                <Form.Item
                                                                    name="emailsubject"
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Please Enter email subject"
                                                                        }
                                                                    ]}>
                                                                    <Input placeholder="Enter Email Subject"
                                                                        onChange={getValueSubjectInput}
                                                                        onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)}
                                                                    />
                                                                </Form.Item>
                                                            </div>
                                                            <div className='d-flex justify-content-center email-editor-wrapper'>
                                                                <div placeholder='enter your data' style={{ border: "1px solid grey", width: "100%" }}
                                                                    id="testAreaId"
                                                                    contenteditable="true" dangerouslySetInnerHTML={{
                                                                        __html:
                                                                            (uploadPreTempDropDown == true) ? inblidEmailTemplate : templateDataEdit

                                                                    }}>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                        :
                                        (getChannelValue?.key == 2 && CreateNewButtonId === true && uploadPreTempDropDown == false && comChanID == 2) ||
                                            (uploadPreTempDropDown == true && selectedChannelID == 2 && ckeditorID == 2) || getChannelValue == 2
                                            ? <>

                                                <Row >
                                                    <Col span={24}>
                                                        <Row className='d-flex justify-content-between mt-2'>
                                                            <Form.Item
                                                                name="addTextOnly"
                                                                className='w-100'
                                                            >
                                                                <Col span={24} xs={24} sm={24} md={24} lg={24} className='w-100' >
                                                                    <h5>SMS-Text</h5>
                                                                    <AtTheRateTextArea id="textAreaAt3" className="textarea_text w-100" rows="4" handleTextUpdate={handleTextUpdate} occuranceId={occuranceId} defaultText={textMessage} placeholder="" />

                                                                </Col>
                                                            </Form.Item>

                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>
                                            :
                                            (getChannelValue?.key == 1 && CreateNewButtonId === true && uploadPreTempDropDown == false) ||
                                                (uploadPreTempDropDown == true && selectedChannelID == 1 && ckeditorID == 1)
                                                ?

                                                <>
                                                    {konsole.log("uploadPreTempDropDown", uploadPreTempDropDown)}

                                                    <Row style={{ position: "sticky", top: " 10px", zIndex: "1" }}>
                                                        <Col span={24} className="d-flex justify-content-end  " >
                                                            <div className={createLinkState == true && getChannelValue?.key == 1 && inblidEmailTemplate?.length == 0 ? 'show-link-with-pre-temp' : uploadPreTempDropDown == true && getChannelValue?.key == 1 && selectedChannelLinkID == 1 ? "show-link-with-pre-temp2" :
                                                                uploadPreTempDropDown == true && getChannelValue?.key == 3 && selectedChannelLinkID == 3 ? "show-link-with-pre-temp3" :
                                                                    uploadPreTempDropDown == true && getChannelValue?.key == 3 && inblidEmailTemplate?.length > 0 ? "show-link-with-pre-temp4" :
                                                                        ''}>

                                                                {getChannelValue?.key == 1 && CreateNewButtonId == true || getChannelValue?.key == 3 && CreateNewButtonId == true
                                                                    || createLinkState == true && getChannelValue?.key == 1 || createLinkState == true && getChannelValue?.key == 3
                                                                    ?

                                                                    <div style={{ width: "40px", height: "35px", marginRight: "10px" }} className=" "
                                                                        onMouseLeave={() => { document.querySelector(".linkicons").style.transform = "scale(1)" }}
                                                                    >
                                                                        <button id="createLink" className="adv-option-button mt-1 "
                                                                            onClick={linkCreateButtonFunction}
                                                                            disabled={isDisabled}
                                                                            style={{ backgroundColor: "white", float: "right", cursor: "pointer", border: "none", }}>
                                                                            <img src="images/link5.jpg" className='img-fluid linkicons' style={{ opacity: ".7" }}
                                                                                onMouseEnter={() => { document.querySelector(".linkicons").style.transform = "scale(1.1)" }}


                                                                            />
                                                                        </button>
                                                                    </div>
                                                                    : ""}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className="" style={{ marginRight: "5px" }}>
                                                        <Col span={24}>
                                                            <Row className='d-flex justify-content-between'>

                                                                <Col span={24} xs={24} sm={24} md={24} lg={24}>
                                                                    <h5>Email Subject</h5>
                                                                    <div className='mb-2'>
                                                                        <Form.Item
                                                                            name="emailsubject"
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: "Please Enter email subject"
                                                                                }
                                                                            ]}>
                                                                            <Input placeholder="Enter Email Subject"
                                                                                onChange={getValueSubjectInput}

                                                                                onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)}
                                                                            />
                                                                        </Form.Item>
                                                                    </div>
                                                                    <div className='d-flex justify-content-center email-editor-wrapper'>

                                                                        <div placeholder='enter your data'
                                                                            style={{ border: "1px solid grey", width: "100%" }}
                                                                            id="testAreaId"
                                                                            contenteditable="true"
                                                                            dangerouslySetInnerHTML={{
                                                                                __html:
                                                                                    (uploadPreTempDropDown == true) ? inblidEmailTemplate : templateDataEdit
                                                                            }}>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </> : ""
                                }
                                {konsole.log("getOccurrenceSelectedValue", templateDataEdit)}

                                <Row className='m-0 pt-3' style={{ height: "" }}>
                                    <Col span={24} className="m-0 p-0 ">
                                        {
                                            (() => {
                                                const isSave =
                                                    (CreateNewButtonId == true && getChannelValue?.key == 1) || (uploadPreTempDropDown == true) || getChannelValue == 1
                                                    || (CreateNewButtonId == true && getChannelValue?.key == 2) || (uploadPreTempDropDown == true) || getChannelValue == 2
                                                    || (CreateNewButtonId == true && getChannelValue?.key == 3) || (uploadPreTempDropDown == true) || getChannelValue == 3;

                                                return (
                                                    <div className={`d-flex align-items-center m-0 p-0 ${isSave ? "justify-content-end me-1" : "justify-content-center"}`}>

                                                        <Button
                                                            className="Add-Edit-btton text-white m-0 p-0"
                                                            htmlType="submit"
                                                            type='primary'
                                                            onClick={() => {
                                                                {
                                                                    firstselect1 && firstselect2 && firstselect3 && firstselect4 ? <>
                                                                        {
                                                                            setlastdata(true)
                                                                        }
                                                                    </>
                                                                        :
                                                                        <>
                                                                            {
                                                                                setlastdata(false)
                                                                            }
                                                                        </>
                                                                }

                                                            }}
                                                            onSubmitFail
                                                            style={{ backgroundColor: "#720c20" }} >

                                                            {isSave ? "Save" : "Create New"}

                                                        </Button>

                                                    </div>
                                                );
                                            })()
                                        }
                                    </Col>
                                </Row>
                                {
                                    uploadPreTempDropDown == false ?
                                        <div>

                                            {(lastdata) ? "" : <>
                                                <Row>
                                                    <Col span={24} className=' d-flex justify-content-center'>
                                                        <h5 style={{ color: "#720c20", fontWeight: "500" }}>or</h5>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24} className=' d-flex justify-content-center'>

                                                        <h6 style={{ color: "#720c20", cursor: "pointer" }}

                                                            onClick={showContentfunction}>
                                                            Choose content from existing template
                                                        </h6>

                                                    </Col>
                                                </Row>
                                            </>
                                            }


                                        </div>
                                        : ""
                                }
                            </ModalBody>

                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div >
    )
}
